import {Injectable} from '@angular/core';

@Injectable()
export class ValidationService {
  static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    const config = {
      'required': 'Required',
      'invalidPhoneNumber': 'Phone Number is invalid',
      'invalidEmailAddress': 'Invalid email address',
      'invalidPassword': 'Invalid password. Password must be at least 6 characters long, and contain a number.',
      'minlength': `Minimum length ${validatorValue.requiredLength}`,
      'maxlength': `Maximum length ${validatorValue.requiredLength}`
    };

    return config[validatorName];
  }


  static phoneValidator(control) {
    if (control.value!=null && control.value.toString().match(/^\d$/)) {
      return null;
    } else {
      return { 'invalidPhoneNumber': true };
    }
  }

  static questionAndChoiceValidation(control) {
    if (control.value!=null && control.value.toString().match(/^\d{1,3}$/)) {
      return null;
    } else {
      return { 'invalidQuestionOrChoice': true };
    }
  }

  static emailValidator(control) {
    // RFC 2822 compliant regex
    if (control.value!=null && control.value.toString().match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
      return null;
    } else {
      return { 'invalidEmailAddress': true };
    }
  }
}
